
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/[...router]",
      function () {
        return require("private-next-pages/[...router].js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/[...router]"])
      });
    }
  